import { Flex, Text, Button, Box, Dialog } from '@radix-ui/themes';
import { Link } from 'react-router-dom';

import {
   CREATE_RESUME_PROFILE_FIELD_LABELS,
} from 'candidate/core/guards/create-resume-profile-access';
import type { CreateResumeProfileField } from 'candidate/core/guards/create-resume-profile-access';
import { AlertTriangleIcon, IconEast } from 'shared/icons';

type ResumeLockScreenProps = {
   missingFields?: CreateResumeProfileField[];
   mode?: 'dialog';
};

export const ResumeLockScreen = ({ missingFields = [], mode }: ResumeLockScreenProps) => {
   const missingFieldLabels = missingFields.map(
      (field) => CREATE_RESUME_PROFILE_FIELD_LABELS[field]
   );

   return (
      <Box className="">
         <Flex
            align="center"
            mt="6"
            justify="center"
            direction="column"
            minHeight="240px"
            gap="3"
            px="4"
         >
            <Flex>
               <AlertTriangleIcon width={60} height={60} color="orange" />
            </Flex>

            <Text align="center" size="4">
               Будь ласка, заповніть поля у профілі, щоб мати можливість створити резюме
            </Text>

            {missingFieldLabels.length > 0 ? (
               <Text align="center" color="red" size="2">
                  Потрібно заповнити:{' '}
                  {missingFieldLabels.join(', ')}
               </Text>
            ) : null}

            {mode === 'dialog' ? (
               <Dialog.Close>
                  <Button size="3" mt="4">
                     Закрити
                  </Button>
               </Dialog.Close>
            ) : (
               <Button asChild size="3" color="blue" highContrast mt="4">
                  <Link to="/candidate/profile">
                     Перейти до профілю <IconEast />
                  </Link>
               </Button>
            )}
         </Flex>
      </Box>
   );
};
